<template>
    <v-card class="add-note-page page pa-7 mb-16 pb-8" style="border-radius: 10px; max-width: 600px;" flat>
        <PageBlocked v-if="isBlocked" :blockRole="blockRole" />
        <v-card-text v-else-if="isBlocked !== null" class='mt-5'>
            <ButtonBack :button="{label: 'Notes'}"/>
            <div class='notes-page__header mt-4'>
                <h2 class="notes-page__title">
                    Choose a Person
                </h2>
                <div class="d-flex justify-space-between notes-search__wrapper">
                    <div class="d-flex w-100 pr-3 align-center notes-search__input">
                        <input
                            type="text"
                            class="px-3 py-2"
                            placeholder="Search"
                            v-model="filters.search"
                            @input="filterSearch"
                            style="outline: none"
                        />
                        <img :src="searchIcon" alt="" />
                    </div>
                </div>
            </div>

            <div>
                <v-skeleton-loader
                    v-if='isLoading'
                    type='list-item-avatar, list-item-avatar, list-item-avatar'
                ></v-skeleton-loader>
                <div v-else>
                    <UserAddNoteItem 
                        v-for="user in users" 
                        :key="user.user_id"
                        :user="user"
                        :selectedUser="selectedUser"
                        v-on:selectUser="selectUser"
                    />
                </div>
            </div>

            <div class='d-flex my-9 justify-center notes-page__pagination'
                v-if='!isLoading && users.length > 0'
            >
                <Pagination 
                    :page="filters.page"
                    :pageCount="+this.pageCountAttendees"
                    v-on:pageChange="onPageChange"
                />
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import searchIcon from '@/assets/images/search.svg'
import UserAddNoteItem from '@/components/Profile/UserAddNoteItem.vue'
import Pagination from '@/components/Pagination.vue'
import ButtonBack from '../../components/ButtonBack.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'

const DEBOUNCE_TIMEOUT = 500

export default {
    components: {
        UserAddNoteItem,
        Pagination,
        ButtonBack,
        PageBlocked
    },
    mixins: [Block],
    data() {
        return {
            searchIcon,
            filters: {
                page: 1,
                search: '',
            },
            selectedUser: null,
            pageBlockedName: 'profile'
        }
    },
    computed: {
        ...mapGetters('event', ['isLoading', 'pageCountAttendees', 'attendees']),
        ...mapGetters('auth', ['profile']),
        ...mapGetters('settings', ['appCore']),

        users() {
            return this.attendees
        }
    },
    methods: {
        ...mapActions('event', ['getAttendeesEvent', 'clearAttendeesEvent']),

        filterSearch(e) {
            clearTimeout(this.timer)

            this.filters.page = 1

            this.timer = setTimeout(() => {
                this.getAttendeesEvent(`page=${1}&search=${e.target.value}`)
            }, DEBOUNCE_TIMEOUT)
        },

        onPageChange(page) {
            if (page !== this.filters.page) {
                this.filters.page = page
                this.getAttendeesEvent(`page=${page}&search=${this.filters.search}`)
            }
        },
        selectUser(user) {
            this.selectedUser = user
        }
    },
    created() {
        !this.isBlocked && this.getAttendeesEvent()
    },
    beforeDestroyed() {
        this.clearAttendeesEvent()
    }
}
</script>

<style lang="scss">
</style>